var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskFailedIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9457_19074",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 27,
    width: 193,
    height: 197
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87 223.5L55 203.5L16 49.5L175.5 27L208.5 210L87 223.5Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9457_19074)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9457_19074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.016 44.3076L35.5074 59.565C31.4588 60.0692 28.6976 63.915 29.5141 67.9123L60.202 218.145C60.9343 221.731 64.3044 224.147 67.9349 223.69L189.07 208.436C193.09 207.929 195.842 204.127 195.066 200.15L165.751 49.9133C165.047 46.3022 161.667 43.8528 158.016 44.3076Z",
    fill: "url(#paint0_linear_9457_19074)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.016 44.3076L35.5074 59.565C31.4588 60.0692 28.6976 63.915 29.5141 67.9123L60.202 218.145C60.9343 221.731 64.3044 224.147 67.9349 223.69L189.07 208.436C193.09 207.929 195.842 204.127 195.066 200.15L165.751 49.9133C165.047 46.3022 161.667 43.8528 158.016 44.3076Z",
    stroke: "white"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 221L57.5 205L73.4875 201.909C77.4424 201.145 81.225 203.868 81.7552 207.861L83.5 221Z",
    fill: "#FFD4D5",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 87.5L138 76.5",
    stroke: "url(#paint1_linear_9457_19074)",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 112.5L155.5 99.5",
    stroke: "url(#paint2_linear_9457_19074)",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66 134.5L142 124.5",
    stroke: "url(#paint3_linear_9457_19074)",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9457_19074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.429 72.5C215.861 72.5001 234.857 87.2746 234.857 105.5C234.857 123.725 215.861 138.5 192.429 138.5C183.36 138.5 174.956 136.285 168.061 132.516L156.286 138.5L161.025 127.691C154.175 121.831 150 114.045 150 105.5C150 87.2746 168.996 72.5 192.429 72.5Z",
    fill: "#FF849A"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.428 110.617C188.454 111.432 188.834 112.206 189.487 112.775C190.141 113.343 191.016 113.661 191.928 113.661C192.839 113.661 193.715 113.343 194.368 112.775C195.022 112.206 195.402 111.432 195.428 110.617V90.544C195.402 89.7289 195.022 88.9548 194.368 88.3864C193.715 87.818 192.839 87.5 191.928 87.5C191.016 87.5 190.141 87.818 189.487 88.3864C188.834 88.9548 188.454 89.7289 188.428 90.544V110.617ZM188.428 119.369C188.428 121.091 190.003 122.5 191.928 122.5C193.853 122.5 195.428 121.091 195.428 119.369C195.428 117.646 193.853 116.237 191.928 116.237C191.001 116.241 190.113 116.572 189.457 117.158C188.801 117.745 188.431 118.539 188.428 119.369Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9457_19074",
    x: 24.8706,
    y: 39.7534,
    width: 174.827,
    height: 188.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9457_19074"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9457_19074",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9457_19074",
    x: 146,
    y: 70.5,
    width: 92.8574,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9457_19074"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9457_19074",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9457_19074",
    x1: 112.25,
    y1: 43.5,
    x2: 112.25,
    y2: 224.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9457_19074",
    x1: 162,
    y1: 75,
    x2: 54.5,
    y2: 84.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9457_19074",
    x1: 166,
    y1: 99.5,
    x2: 60,
    y2: 112.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9457_19074",
    x1: 156,
    y1: 117,
    x2: 62,
    y2: 129.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskFailedIllustration);
export default __webpack_public_path__ + "static/media/taskFailedIllustration.9065af5943ad9e78771f588cf0881d0d.svg";
export { ForwardRef as ReactComponent };